//
const nav = {

	"admin_menu": [
		{	
			'nav'       : 'Dashboard',
            'icon'      : 'layout',
            'path'      : '/',
            'selected'  : '/',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : '',
                    'path'      : '/',
                    'selected'  : '/'
                }
            ]
        },
		{	
			'nav'       : 'Organization',
            'icon'      : 'home',
            'selected'  : '/organization',
            'disabled'  : false,
            'sub'   : [
                {
                    'nav'       : 'Company Profile',
                    'path'      : '/organization/companyprofile',
                    'selected'  : '/organization/companyprofile',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Employees',
                    'path'      : '/organization/employees',
                    'selected'  : '/organization/employees',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Departments',
                    'path'      : '/organization/department',
                    'selected'  : '/organization/department',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Designations',
                    'path'      : '/organization/designation',
                    'selected'  : '/organization/designation',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Assets',
                    'path'      : '/organization/assets',
                    'selected'  : '/organization/assets',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Permission',
                    'path'      : '/organization/permissions',
                    'selected'  : '/organization/permissions',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Announcements',
                    'path'      : '/organization/announcements',
                    'selected'  : '/organization/announcements',
                    'disabled'  : false,
                },
                
                
            ]
        },
		{	
			'nav'       : 'Leave Management',
            'icon'      : 'calendar',
            'selected'  : '/leavetrack/all',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'         : 'Leave Tracker',
                    'path'        : '/leavetrack/all',
                    'selected'    : '/leavetrack/all',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Leaves',
                    'path'      : '/organization/leaves',
                    'selected'  : '/organization/leaves',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Leave Types',
                    'path'      : '/organization/leavetype',
                    'selected'  : '/organization/leavetype',
                    'disabled'  : false,
                },
                {
                    'nav'       : 'Compassionate Leaves',
                    'path'      : '/compassionate',
                    'selected'  : '/compassionate',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Holidays',
                    'path'      : '/organization/holidays',
                    'selected'  : '/organization/holidays',
                    'disabled'  : false,
                },
                {
                    'nav'       : 'Carry Forward',
                    'path'      : '/organization/carryforward',
                    'selected'  : '/organization/carryforward',
                    'disabled'  : false,
                }
            ]
        },
		{	
			'nav'       : 'Travel Requisition',
            'icon'      : 'tag-o',
            'path'      : '/travel',
            'selected'  : '/travel',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'        : 'Travel Requisition',
                    'path'       : '/travel',
                    'selected'   : '/travel',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'Meetings',
            'icon'      : 'usergroup-add',
            'path'      : '/meetings',
            'selected'  : '/meetings',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Meetings',
                    'path'      : '/meetings',
                    'selected'  : '/meetings',
                    'disabled'  : false,
                }
            ]
        },
        {
            'nav'       : 'Expense Reimbursement',
            'icon'      : 'dollar',
            'path'      : '/expense',
            'selected'  : '/expense',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Expense Reimbursement',
                    'path'      : '/expense',
                    'selected'  : '/expense',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'HR Requests',
            'icon'      : 'solution',
            'selected'  : '/requests',
            'disabled'  : false,
            'sub'   : [
                // {
                //     'nav'       : 'Candidate Onboarding',
                //     'path'      : '/requests/onboarding',
                //     'selected'  : '/requests/onboarding',
                //     'disabled'  : false,
                // },
                {
                    'nav'       : 'Letter Application Form',
                    'path'      : '/requests/letter',
                    'selected'  : '/requests/letter',
                    'disabled'  : false
                },
                {
                    'nav'       : 'Resignation',
                    'path'      : '/requests/resignation',
                    'selected'  : '/requests/resignation',
                    'disabled'  : false,
                },
            ]
        },
        
        { 
            'nav'       : 'Reports',
            'icon'      : 'copy',
            'selected'  : '/reports',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Leaves',
                    'path'      : '/reports',
                    'selected'  : '/reports',
                    'disabled'  : false,
                },
                {
                    'nav'       : 'Meetings',
                    'path'      : '/hr-reports/meetings/',
                    'selected'  : '/hr-reports/meetings/',
                    'disabled'  : false,
                },
                {
                    'nav'       : 'Expenses',
                    'path'      : '/hr-reports/expense/',
                    'selected'  : '/hr-reports/expense/',
                    'disabled'  : false,
                },
            ]
        },
        {	
			'nav'       : 'Approvals',
            'icon'      : 'check-circle-o',
            'path'      : '/approvals',
            'selected'  : '/approvals',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Approvals',
                    'path'      : '/approvals',
                    'selected'  : '/approvals',
                    'disabled'  : false,
                }
            ]
        },
        
        {
            'nav'       : 'Settings',
            'icon'      : 'setting',
            'selected'  : '/settings',
            'disabled'  : false,
            'sub'       : [
                {
                    'nav'       : 'Check List',
                    'path'      : '/settings/checklist/',
                    'selected'  : '/settings/checklist/',
                    'disabled'  : false,
                },
                {
                    'nav'       : '',
                    'path'      : '/settings/checklist_',
                    'selected'  : '/settings/checklist_',
                    'disabled'  : true,
                },
            ]
        },
        
        
    ],

    // _______________________________________________
    "user_menu": [
		{	
			'nav'       : 'Dashboard',
            'icon'      : 'layout',
            'path'      : '/',
            'selected'  : '/',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : '',
                    'path'      : '/',
                    'selected'  : '/'
                }
            ]
        },
		{	
			'nav'       : 'Organization',
            'icon'      : 'home',
            'selected'  : '/organization',
            'disabled'  : false,
            'sub'   : [
                {
                    'nav'       : 'Company Profile',
                    'path'      : '/organization/companyprofile',
                    'selected'  : '/organization/companyprofile',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Employees',
                    'path'      : '/organization/employees',
                    'selected'  : '/organization/employees',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Departments',
                    'path'      : '/organization/department',
                    'selected'  : '/organization/department',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Designations',
                    'path'      : '/organization/designation',
                    'selected'  : '/organization/designation',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Leave Types',
                    'path'      : '/organization/leavetype',
                    'selected'  : '/organization/leavetype',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Leaves',
                    'path'      : '/organization/leaves',
                    'selected'  : '/organization/leaves',
                    'disabled'  : false,
                },
                {
                    'nav'       : 'Compassionate Leaves',
                    'path'      : '/compassionate',
                    'selected'  : '/compassionate',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Holidays',
                    'path'      : '/organization/holidays',
                    'selected'  : '/organization/holidays',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Announcements',
                    'path'      : '/organization/announcements',
                    'selected'  : '/organization/announcements',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Assets',
                    'path'      : '/organization/assets',
                    'selected'  : '/organization/assets',
                    'disabled'  : false,
                },
                { 
                    'nav'       : 'Permission',
                    'path'      : '/organization/permissions',
                    'selected'  : '/organization/permissions',
                    'disabled'  : false,
                },
            ]
        },
		{	
			'nav'       : 'Leave Management',
            'icon'      : 'calendar',
            'path'      : '/leavetrack/all',
            'selected'  : '/leavetrack/all',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'         : 'Leave Tracker',
                    'path'        : '/leavetrack/all',
                    'selected'    : '/leavetrack/all',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'Meetings',
            'icon'      : 'usergroup-add',
            'path'      : '/meetings',
            'selected'  : '/meetings',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Meetings',
                    'path'      : '/meetings',
                    'selected'  : '/meetings',
                    'disabled'  : false,
                }
            ]
        },
        {
            'nav'       : 'Expense Reimbursement',
            'icon'      : 'dollar',
            'path'      : '/expense',
            'selected'  : '/expense',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Expense Reimbursement',
                    'path'      : '/expense',
                    'selected'  : '/expense',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'Travel Requisition',
            'icon'      : 'tag-o',
            'path'      : '/travel',
            'selected'  : '/travel',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'        : 'Travel Requisition',
                    'path'       : '/travel',
                    'selected'   : '/travel',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'Requests',
            'icon'      : 'solution',
            'selected'  : '/requests',
            'disabled'  : false,
            'sub'   : [
                // {
                //     'nav'       : 'Candidate Onboarding',
                //     'path'      : '/requests/onboarding',
                //     'selected'  : '/requests/onboarding',
                //     'disabled'  : false,
                // },
                {
                    'nav'       : 'Letter Application Form',
                    'path'      : '/requests/letter',
                    'selected'  : '/requests/letter',
                    'disabled'  : false
                },
                {
                    'nav'       : 'Resignation',
                    'path'      : '/requests/resignation',
                    'selected'  : '/requests/resignation',
                    'disabled'  : false,
                },
            ]
        },
        { 
            'nav'       : 'Reports',
            'icon'      : 'copy',
            'path'      : '/reports',
            'selected'  : '/reports',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Reports',
                    'path'      : '/reports',
                    'selected'  : '/reports',
                    'disabled'  : false,
                }
            ]
        },
        {	
			'nav'       : 'Approvals',
            'icon'      : 'check-circle-o',
            'path'      : '/approvals',
            'selected'  : '/approvals',
            'disabled'  : false,
            'sub'       : [
                { 
                    'nav'       : 'Approvals',
                    'path'      : '/approvals',
                    'selected'  : '/approvals',
                    'disabled'  : false,
                }
            ]
        },
        
	]

}

export default nav;



// WEBPACK FOOTER //
// ./src/components/sidebar/nav.config.js